import * as React from 'react';
import {useEffect} from 'react';

interface SnackbarProps {
    message: string;
    setShow?: React.Dispatch<boolean>;
    show: boolean;
    useSetAutoState?: boolean;
}

export const Snackbar = ({message, setShow, show, useSetAutoState = false}: SnackbarProps) => {
    const [useShow, setUseShow] = React.useState(show);

    useEffect(() => {
        if (useSetAutoState) {
            setTimeout(() => {
                setUseShow(false);
            }, 2000);
        } else {
            setTimeout(() => {
                setShow(false);
            }, 2000);
        }
    }, [useSetAutoState, setUseShow, setShow, show, useShow]);

    const getShowBoolean = () => {
        if (useSetAutoState) {
            return useShow;
        } else {
            return show;
        }
    };

    /**
     * Template
     */
    return (
        <div
            className={`tw-bg-blue-100 tw-leading-[60px] tw-block tw-my-auto tw-text-white tw-text-xl tw-overflow-hidden tw-fixed tw-text-center tw-top-0 tw-left-0 tw-transition-all tw-ease-in-out tw-duration-500 tw-w-full tw-z-[1200] ${
                getShowBoolean() ? `tw-h-[60px]` : `tw-h-0`
            }`}
        >
            {message}
        </div>
    );
};
